<template>
    <section class="table-data">
        <table>
            <thead>
                <tr>
                    <th v-for="item in tableInfo.title" :style="item.style">{{ item.name }}</th>
                </tr>
            </thead>
            <tbody v-if="tableInfo.data && tableInfo.data.length > 0">
                <tr v-for="item in tableInfo.data">
                    <td
                        v-for="val in item"
                        v-html="val.value === null ? '--' : val.value"
                        :style="val.style"
                        @click="val.showTc ? showTc(val.params) : function () {}"
                        :title="formatTitle(val.value)"
                    >
                    </td>
                </tr>
            </tbody>
            <tbody v-if="!tableInfo.data || tableInfo.data.length === 0">
                <tr>
                    <td style="text-align: center;" :colspan="tableInfo.title.length">暂无数据</td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<style lang="scss">
    .table-data {
        display: inline-block;
        width: 100%;
        vertical-align: top;
        > table {
            width: 100%;
            height: 100%;
            > thead {
                tr {
                    height: 45px;
                    background-color: #F7F9FA;
                    th {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        &:nth-child(1) {
                            text-align: left;
                            padding-left: 20px;
                        }
                        &:nth-child(n+2) {
                            text-align: right;
                            padding: 0 10px;
                        }
                    }
                }
            }
            > tbody {
                tr {
                    border-bottom: 1px solid #E9EEF0;
                    height: 50px;
                    &:hover {
                        box-shadow: 0 0 15px 0 rgba(251, 197, 89, 0.52);
                    }
                    td {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        &:nth-child(1) {
                            text-align: left;
                            padding-left: 20px;
                        }
                        &:nth-child(n+2) {
                            text-align: right;
                            padding: 0 10px;
                        }
                        > span {
                            display: inline-block;
                            width: 18px;
                            height: 18px;
                            color: #FFF;
                            background-color: #FF2F40;
                            border-radius: 2px;
                            text-align: center;
                            line-height: 18px;
                            margin-right: 10px;
                            font-size: 12px;
                        }
                        > a {
                            color: #2CA4F7;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import { eventBus } from 'helpers/index'

    export default {
        data () {
            return {
            }
        },
        props: ["tableInfo"],
        methods: {
            // 格式化title属性
            formatTitle (val) {
                return val !== null ? String(val).replace(/<span.+<\/span>/g, '') : '';
            },

	        // 显示弹层
	        showTc (params) {
		        eventBus.$emit('showTc', params);
	        }
        }
    }
</script>






// WEBPACK FOOTER //
// Table.vue?67c87b13